import React from "react";
import {Box, Typography} from "@mui/material";
import OpenerCloserComponent, {Competition} from "../OpenerCloserComponent/OpenerCloserComponent";
import AudioFadingCollapse from "../AudioFadingCollapse/AudioFadingCollapse";
import {fadeDurationStep, maxAudioFadeDuration, minAudioFadeDuration} from "../../../utils/constants";
import {OpenerCloserObject} from "../../../types/opernerCloserTypes";
import {defaultOpenerCloserObject} from "../OpenerCloserComponent/OpenerCloserContentComponent";
import {Song} from "../../../types/generic";
import SongSelection from "../SongSelection/SongSelection";
import {useTheme} from "../../../contexts/theme";
import CustomDivider from "../CustomDivider/CustomDivider";


interface HighlightSettingProps {
    title: string
    needOpenerCloserSelection: boolean;
    competition?: Competition;
    opener?: OpenerCloserObject;
    closer?: OpenerCloserObject;
    onOpenerSelectionChange?: (opener: OpenerCloserObject) => void;
    onCloserSelectionChange?: (closer: OpenerCloserObject) => void;
    needFadeSelection: boolean;
    fade?: boolean
    fade_duration?: number;
    onFadeSelectionChange?: (fade: boolean) => void;
    onFadeDurationSelectionChange?: (fade_duration: number) => void;
    needSongSelection: boolean;
    music?: Song
    onSongSelectionChange?: (song: Song) => void;
    loadOpenerCloserTrigger: boolean,
}

const HighlightSetting: React.FC<HighlightSettingProps> = ({
    needSongSelection,
    music,
    opener = defaultOpenerCloserObject,
    closer = defaultOpenerCloserObject,
    onFadeDurationSelectionChange = () => {},
    onCloserSelectionChange = () => {},
    onOpenerSelectionChange = () => {},
    fade = false,
    needFadeSelection,
    onFadeSelectionChange = () => {},
    onSongSelectionChange = () => {},
    needOpenerCloserSelection,
    fade_duration = minAudioFadeDuration,
    competition,
    loadOpenerCloserTrigger,
    title
}) => {

    const theme = useTheme();

    return (
        <Box>
            <Box display={'flex'} alignItems={'center'} width={'100%'}>
                <Typography variant={'subtitle1'} sx={{color: theme.palette.white}}>{title}</Typography>
                <CustomDivider />
            </Box>
            <Box>
                {needOpenerCloserSelection && <OpenerCloserComponent
                    selectedCompetition={competition}
                    setSelectedCompetition={() => {}}
                    dynamicCompetitions={true}
                    selectedItemsCompetitions={[]}
                    multi_event={false}
                    selectedOpener={opener}
                    setSelectedOpener={(opener) => onOpenerSelectionChange(opener)}
                    selectedCloser={closer}
                    setSelectedCloser={(closer) => onCloserSelectionChange(closer)}
                    isCollapseOpen={loadOpenerCloserTrigger}
                />}
                {needFadeSelection && <AudioFadingCollapse
                    fade={fade}
                    fadeDuration={fade_duration}
                    fadeDurationStep={fadeDurationStep}
                    maxFadeDuration={maxAudioFadeDuration}
                    minFadeDuration={minAudioFadeDuration}
                    onFadeChange={onFadeSelectionChange}
                    onFadeDurationChange={onFadeDurationSelectionChange}
                />}
                {needSongSelection && <SongSelection
                    music={music ? music : null}
                    onSongChange={onSongSelectionChange}
                />
                }
            </Box>
        </Box>
    )
}
export default HighlightSetting